import clsx from 'clsx'

const SkeletonImage = () => {
  return (
    <div class="relative w-full aspect-1/1 bg-neutral-light overflow-hidden animate-pulse">
    </div>
  )
}

const SkeletonDetails = () => {
  return (
    <div class="grow flex flex-col gap-y-0.5 px-0.5 lg:px-1">
      <div class="flex lg-max:flex-col justify-between gap-y-0.25">
        <div class="w-full h-1.125 bg-neutral-light"></div>
        <div class="w-full h-1.125 bg-neutral-light"></div>
      </div>
      <div class="flex lg-max:flex-col justify-between gap-y-0.5 pb-0.125">
        <div class="w-full h-1.25 bg-neutral-light"></div>
        <div class="w-full h-1.25 bg-neutral-light"></div>
      </div>
    </div>
  )
}

export const SkeletonCard = ({ className }) => {
  return (
    <div class={clsx('flex flex-col gap-y-1 w-full grow', className)}>
      <SkeletonImage />
      <SkeletonDetails />
    </div>
  )
}
